import React, { useEffect } from 'react'

import { Spinner } from '@wartek-id/spinner'

import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

export function PageGuardPamong({ children }: { children: React.ReactNode }) {
  const { isPamong, isSuccess, leave } = useRoleContext()

  useEffect(() => {
    if (isSuccess && !isPamong) {
      leave()
    }
  }, [isSuccess, isPamong, leave])

  if (!isSuccess || !isPamong)
    return (
      <div className="flex p-10">
        <div className="m-auto">
          <Spinner data-testid="loading-spinner-content" />
        </div>
      </div>
    )

  return <>{children}</>
}
